import { makeAutoObservable } from "mobx";
import type { DepthAryProps, TickerProps, TradeRecentProps } from "./trade";

interface CfdViewState {
  cfdTicker: WithUndefined<TickerProps>;
  cfdTickerUpdateTime: WithUndefined<number>;
  lastKlineBarTime: WithUndefined<number>;
  depthAsks: WithUndefined<DepthAryProps>;
  depthBids: WithUndefined<DepthAryProps>;
  tradeRecent: WithUndefined<TradeRecentProps | null>;
  positionTickers: Record<string, TickerProps>;
  /** 当前用户全部 CFD 持仓（原始 API 数据，由 PositionList 写入） */
  cfdOpenPositionsRaw: any[];
}

const cfdView = makeAutoObservable(
  {
    cfdTicker: undefined as CfdViewState["cfdTicker"],
    cfdTickerUpdateTime: undefined as CfdViewState["cfdTickerUpdateTime"],
    lastKlineBarTime: undefined as CfdViewState["lastKlineBarTime"],
    depthAsks: undefined as CfdViewState["depthAsks"],
    depthBids: undefined as CfdViewState["depthBids"],
    tradeRecent: undefined as CfdViewState["tradeRecent"],
    positionTickers: {} as CfdViewState["positionTickers"],
    cfdOpenPositionsRaw: [] as CfdViewState["cfdOpenPositionsRaw"],

    updateState(payload: Partial<CfdViewState>) {
      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          (this as any)[key] = payload[key];
        }
      }
    },
  },
  {},
  { autoBind: true, deep: false }
);

export default cfdView;
